import { isValidElement } from "react";
import { ConditionalViewProps } from "./ConditionalView.types";

const ConditionalView = ({ condition, children }: ConditionalViewProps) => {
  // If condition is another ConditionalView, ignore our condition and return children directly
  if (isValidElement(condition) && condition.type === ConditionalView) {
    return Boolean(condition.props.condition) ? children : null;
  }
  
  return Boolean(condition) ? children : null;
};

export default ConditionalView;
